import GeoLocationDisclaimerModal from 'components/Happening/ExperienceLocation/GeoLocationDisclaimerModal/GeoLocationDisclaimerModal';

export default GeoLocationDisclaimerModal;
